var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyArtisWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6104",
    "data-name": "Group 6104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.757,
    height: 42.283,
    viewBox: "0 0 75.757 42.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 75.757,
    height: 42.283,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6004",
    "data-name": "Group 6004",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6003",
    "data-name": "Group 6003",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M199.687,42.283c-.822-.857-1.63-1.729-2.47-2.568-3.6-3.6-7.209-7.19-10.761-10.73l4.417-4.379,8.786,8.78L233.114,0l4.772,4.748a4.359,4.359,0,0,0-.928.568q-17.022,16.955-34.023,33.932-1.52,1.516-3.038,3.035Z",
    transform: "translate(-162.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M4.452,41.543,0,37.093,35.324,1.924l13.168,13L44.115,19.3l-8.659-8.695-31,30.937",
    transform: "translate(0 -1.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M455.716,219.367l-4.195,4.134-8.139-8.156,4.177-4.121,8.157,8.143",
    transform: "translate(-385.536 -183.666)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyArtisWhite);
export default __webpack_public_path__ + "static/media/company-artis-white.c15c6adfab55265834e28df00a8bc7ec.svg";
export { ForwardRef as ReactComponent };